/** Zone de texte — même charte que Field. */
import type { TextareaHTMLAttributes, ReactNode } from "react";

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  hint?: ReactNode;
};

export function TextArea({ label, hint, id, className = "", rows = 4, ...rest }: TextAreaProps) {
  const inputId = id || rest.name;
  return (
    <label className="fx-field flex flex-col gap-1 text-xs" htmlFor={inputId}>
      {label}
      <textarea
        id={inputId}
        rows={rows}
        className={`rounded-md border px-2.5 py-2 text-sm ${className}`}
        {...rest}
      />
      {hint ? <span className="text-slate-500">{hint}</span> : null}
    </label>
  );
}
